const LossPointStateReducers = (state = true, action) => {
  //此Reducers是用來判斷當 玩家的狀態碼(status)為5(凍結輸分)時
  // 可以進行遊戲，但是無法透過紙鈔機進行充值
  //所以要在用戶初次載入頁面時，彈出提示框告知用戶目前狀態為凍結輸分，不可進行充值
  //故初始狀態會為true,通知後會變成false
  //會與 UPDATE_DATA_PERIODICALLY 這個action一起使用
  switch (action.type) {
    case "ALREADY_SHOW_LOSS_POINT_MODAL_STATE":
      //顯示過的話調用此action
      return (state = false);
    case "RESET_LOSS_POINT_MODAL_STATE":
      //重設狀態
      return (state = true);
    default:
      return state;
  }
};
export default LossPointStateReducers;
